'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const uuid = require('uuid');
const Moment = require('moment');
const assign = require('lodash/assign');
const forEach = require('lodash/forEach');
const find = require('lodash/find');
const clone = require('lodash/clone');
const filter = require('lodash/filter');
const uniq = require('lodash/uniq');
const map = require('lodash/map');

import Navigator from '../../Navigator';

const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ServerRequest = require('../../actions/request');
const SignInStore = require('../../stores/SignInStore');
const GlobalUserStore = require('../../stores/GlobalUserStore');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const ActivityStore = require('../../stores/activity_store_reflux');
const ActivityActions = require('../../actions/ActivityActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const ShortCourseActions = require('../../actions/ShortCourseActions');

import ConfirmModal from '../modal/ConfirmModal';


const propTypes = {
    history: PropTypes.object.isRequired,
};
const defaultProps = {};

class CommentWidget extends React.Component {
    constructor(props) {
        super(props);
        
        this.selectActivity = this.selectActivity.bind(this); 
        this.selectComment = this.selectComment.bind(this); 
        this.refreshComments = this.refreshComments.bind(this);
        this.textEllipse = this.textEllipse.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
        this.onFinishNavigatingToComment = this.onFinishNavigatingToComment.bind(this);
        
        this.state = {
            signInStoreState: SignInStore.getState(),
            globalUserStoreState: GlobalUserStore.getState(),
            channelStoreState: ChannelStore.getState(),
            projectStoreState: ProjectStore.getState(),
            //activityStoreState: ActivityStore.getState(),
            actionId: '',
            expandedActivities: {},
            expandedShortCourses: {},
            navigatingToComment: null,
            checkedActivityIds: [],
            checkedShortCourseIds: [],
            hiddenActivityIds: [],
            hiddenShortCourseIds: [],
        };
        this.unsubscribes = [ 
            SignInStore.listen(this.onSignInStoreStateChange.bind(this)),
            GlobalUserStore.listen(this.onGlobalUserStoreStateChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
            ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this)),
        ];
    }
    
    componentDidMount() {
        this.refreshComments();
        this._pollTimer = window.setInterval(this.refreshComments,5*60*1000);
    }
    
    componentWillUnmount() {
        window.clearInterval(this._pollTimer);
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback() });
    }

    refreshComments() {
        // console.log("refreshComments");
        let actionId = uuid.v4();
        GlobalUserActions.getComments(actionId, 'me');
        this.setState({actionId: actionId});
    }
    
    onSignInStoreStateChange(newState) {
        this.setState({
            signInStoreState: newState
        });
    }
    
    onGlobalUserStoreStateChange(newState) {
        let updatedState = {
            globalUserStoreState: newState
        };
        if (this.state.actionId && (newState.action.id === this.state.actionId)) {
            updatedState.error = newState.action.error;
        }
        this.setState(updatedState,()=>{
            this.checkHiddenComments();
        });
    }

    // Postgres-only (no mongo) batch check for whether the activities/short courses referenced by
    // comments have been deleted or archived, so their comments can be hidden. Only checks ids not
    // already checked, so it costs nothing on repeat comment refreshes (redmine #7612).
    checkHiddenComments() {
        const comments = this.state.globalUserStoreState.comments || [];
        const newActivityIds = uniq(map(filter(comments,(c)=>(c.activity_id && !this.state.checkedActivityIds.includes(c.activity_id))),'activity_id'));
        const newShortCourseIds = uniq(map(filter(comments,(c)=>(c.short_course_id && !this.state.checkedShortCourseIds.includes(c.short_course_id))),'short_course_id'));

        if (!newActivityIds.length && !newShortCourseIds.length) {
            return;
        }

        ServerRequest.makeRequest('/authoring/comments/hidden_ids', 'POST', JSON.stringify({
            activityIds: newActivityIds,
            shortCourseIds: newShortCourseIds,
        }))
        .then((res)=>{
            res = res || {};
            this.setState({
                checkedActivityIds: this.state.checkedActivityIds.concat(newActivityIds),
                checkedShortCourseIds: this.state.checkedShortCourseIds.concat(newShortCourseIds),
                hiddenActivityIds: this.state.hiddenActivityIds.concat(res.hiddenActivityIds || []),
                hiddenShortCourseIds: this.state.hiddenShortCourseIds.concat(res.hiddenShortCourseIds || []),
            });
        })
        .catch((err)=>{
            console.warn('checkHiddenComments failed',err);
        });
    }

    onChannelStoreChange(state) {
        this.setState({ channelStoreState: state });
    }

    onProjectStoreChange(state) {
        this.setState({ projectStoreState: state });
    }

    
    onActivityStoreChange(state) {
        var changes = {};
        let gotoComment;
        var ntc = this.state.navigatingToComment;
        if (ntc) {
            if (state.action.id === ntc.actionId) {
                if (state.action.error) {
                    // lock status fetch failed -- most likely the activity was deleted/archived
                    // since the last check; hide it instead of navigating into it (redmine #7612)
                    assign(changes,{
                        navigatingToComment: null,
                        hiddenActivityIds: this.state.hiddenActivityIds.concat([ntc.comment.activity_id]),
                    });
                }
                else {
                    gotoComment = ntc.comment;
                    assign(changes,{
                        navigatingToComment: null,
                    });
                }
            }
            else {
                // check for timeout
                var elapsed = Date.now() - ntc.startTime;
                if (elapsed > 15000) {
                    if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                        console.log("timed out waiting for lock data during comment navigation");
                    }
                    assign(changes,{
                        navigatingToComment: null,
                    });
                }
            }
        }
        this.setState(changes,()=>{
            if (gotoComment) {
                this.onFinishNavigatingToComment(gotoComment);
            }
        });
        
    }

    onShortCourseStoreChange(state) {
        var changes = {};
        let gotoComment;
        var ntc = this.state.navigatingToComment;
        if (ntc) {
            if (state.action.id === ntc.actionId) {
                if (state.action.error) {
                    // lock status fetch failed -- most likely the short course was deleted/archived
                    // since the last check; hide it instead of navigating into it (redmine #7612)
                    assign(changes,{
                        navigatingToComment: null,
                        hiddenShortCourseIds: this.state.hiddenShortCourseIds.concat([ntc.comment.short_course_id]),
                    });
                }
                else {
                    gotoComment = ntc.comment;
                    assign(changes,{
                        navigatingToComment: null,
                    });
                }
            }
            else {
                // check for timeout
                var elapsed = Date.now() - ntc.startTime;
                if (elapsed > 15000) {
                    if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                        console.log("timed out waiting for lock data during comment navigation");
                    }
                    assign(changes,{
                        navigatingToComment: null,
                    });
                }
            }
        }
        this.setState(changes,()=>{
            if (gotoComment) {
                this.onFinishNavigatingToComment(gotoComment);
            }
        });

    }

    // refreshActivitiesAndShortCourses() removed (redmine #7612) -- it polled a full
    // activities/short-courses fetch per project every 5 min just to gate comment visibility.

    // id is the first comment id for an activity
    selectActivity(id) {
        /* don't do anything (except toggle expand/collapse)
        const comment = find(this.state.globalUserStoreState.comments,{id:id});
        if (comment) {
            var history = this.props.history;
            history.push(`/dashboard`);
            window.setTimeout(()=>{
                history.push(`/project/${comment.channel_id}/${comment.project_id}/activity/${comment.activity_id}`);
            },1)
        }
        */
    }

    selectComment(id) {
        if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
            console.log("selectComment " + id);
        }
        if (this.state.navigatingToComment) {
            if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                console.log("navigating in process");
            }
            return;
        }
        const comment = find(this.state.globalUserStoreState.comments,{id:id});
        if (comment) {
            let actionId = uuid.v4();
            this.setState({
                navigatingToComment: {
                    actionId: actionId,
                    comment: comment,
                    startTime: Date.now(),
                },
            }, () => {
                if (comment.activity_id) {
                    ActivityActions.getActivityLockStatus(actionId, { activityId: comment.activity_id, projectId: comment.project_id });
                }
                else {
                    ShortCourseActions.getEditLockStatus(actionId, { shortCourseId: comment.short_course_id, projectId: comment.project_id });
                }
            });
        }
    }
    
    doConfirm=(modalTitle,text,onAnswer)=>{
        let confirmHandler=()=>{
            this.setState({modalState:null},()=>{
                onAnswer(true);
            });
        };
        let cancelHandler=()=>{
            this.setState({modalState:null},()=>{
                onAnswer(false);
            });
        };
        this.setState({modalState: {
            modalTitle, text, confirmHandler, cancelHandler,
        }})
    }
    
    onFinishNavigatingToComment(comment,confirmReviewInstead) {
        const channelStoreState = ChannelStore.getStateChannel(comment.channel_id);
        const projectStoreState = ProjectStore.getStateProject(comment.project_id);
        if (!channelStoreState || !projectStoreState) {
            return;
        }
        
        const channel = channelStoreState.channel;
        const _project = comment.short_course_id ? projectStoreState.shortCourseProject : projectStoreState.project;

        if (comment.activity_id) {
            const activityState = ActivityStore.getStateActivity(comment.activity_id, comment.project_id, comment.channel_id);
            
            let route_suffix = '';
            
            if (activityState) {
                const activityLock = activityState.activityLock;
                const activityLocked = activityLock && activityLock.locked;
                const activityLockStale = activityLock && activityLock.lockStale;
                
                const may_edit = PermissionsUtil.canEditActivity(channel.user_permissions, _project.user_permissions);
                if (may_edit && (!activityLocked || activityLockStale)) {
                    route_suffix = '/edit';
                }
                else if (PermissionsUtil.canReviewActivity(channel.user_permissions, _project.user_permissions)) {
                    if (may_edit) {
                        if (confirmReviewInstead) {
                            route_suffix = '/review';
                        }
                        else if (confirmReviewInstead !== false) {
                            return this.doConfirm("Go To Comment","activity locked. Review instead?",(answer)=>{
                                this.onFinishNavigatingToComment(comment,answer);
                            });
                        }
                    }
                    else {
                        route_suffix = '/review';
                    }
                }
                else if (may_edit) {
                    // console.log("activity was locked so we'll just go to the page.");
                }
            }
            else {
                if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                    console.log("CommentWidget: missing activityState, channelStoreState, and/or projectStoreState");
                }
            }
            
            const history = this.props.history;
            Navigator.goToDashboardAuthor(history);
            window.setTimeout(()=>{
                if (route_suffix) {
                    // tell the editor to navigate to the particular comment, after giving it a chance to load.
                    ActivityStore.setEditGotoComment(comment.activity_id, comment.id);
                }
                history.push(`/project/${comment.channel_id}/${comment.project_id}/activity/${comment.activity_id}${route_suffix}`);
            },1)
        } // if activity related comment
        else {
            const shortCourseState = ShortCourseStore.getStateShortCourse(comment.short_course_id, comment.project_id, comment.channel_id);
            
            let route_suffix = '';
            
            if (shortCourseState) {
                const editLock = shortCourseState.editLock;
                const editLocked = editLock && editLock.locked;
                const editLockStale = editLock && editLock.lockStale;
                
                const may_edit = PermissionsUtil.canEditShortCourse(channel.user_permissions, _project.user_permissions);
                if (may_edit && (!editLocked || editLockStale)) {
                    route_suffix = '/edit';
                }
                else if (PermissionsUtil.canReviewShortCourse(channel.user_permissions, _project.user_permissions)) {
                    if (may_edit) {
                        if (confirmReviewInstead) {
                            route_suffix = '/review';
                        }
                        else if (confirmReviewInstead !== false) {
                            return this.doConfirm("Go To Comment","short course locked. Review instead?",(answer)=>{
                                this.onFinishNavigatingToComment(comment,answer);
                            });
                        }
                    }
                    else {
                        route_suffix = '/review';
                    }
                }
                else if (may_edit) {
                    // console.log("activity was locked so we'll just go to the page.");
                }
            }
            else {
                if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                    console.log("CommentWidget: missing activityState, channelStoreState, and/or projectStoreState");
                }
            }
            
            const history = this.props.history;
            Navigator.goToDashboardAuthor(history);
            window.setTimeout(()=>{
                if (route_suffix) {
                    // tell the editor to navigate to the particular comment, after giving it a chance to load.
                    ShortCourseStore.setEditGotoComment(comment.short_course_id, comment.id);
                }
                history.push(`/project/${comment.channel_id}/${comment.project_id}/short_course/${comment.short_course_id}${route_suffix}`);
            },1)
        } // else ( short course )
    }
    
    textEllipse(text,maxChars) {
        if (text.length <= maxChars) {
            return text;
        }
        return (text.slice(0,maxChars - 2) + '...');
    }
    
    toggleExpandedActivity=(act_id,e)=>{
        e.stopPropagation();
        var expandedActivities = clone(this.state.expandedActivities);
        expandedActivities[act_id] = !expandedActivities[act_id];
        this.setState({
            expandedActivities: expandedActivities
        });
    }

    toggleExpandedShortCourse(short_course_id,e) {
        e.stopPropagation();
        var expandedShortCourses = clone(this.state.expandedShortCourses);
        expandedShortCourses[short_course_id] = !expandedShortCourses[short_course_id];
        this.setState({
            expandedShortCourses: expandedShortCourses
        });
    }

    
    stopPropagation(e) {
        e.stopPropagation();
    }
    
    renderMenuItem=(params)=>{
        let { key, item, elems, lineText, lineDate, expanded, toggleExpanded } = params;
        return (
            <li className='AriaMenuButton-menuItemWrapper' key={key}>
                <MenuItem className='AriaMenuButton-menuItem' value={item.id} text={lineText}>
                    <div className="activity-line"  
                            role="button"
                            title={expanded ? "collapse":"expand"}
                            onClick={toggleExpanded}>
                        <span className={"expand-icon fa fa-caret-" + (expanded ? "down":"right")}/>
                        <span className={"activity-header" + (expanded ? " expanded" : " collapsed")}>
                            <span className="activity-date">{lineDate}</span>
                            <span className="num-act-comments">{elems.length}</span>
                            <span className="activity-line-text">
                                {lineText}
                            </span>
                        </span>
                        <ul className="exp-selectable-list" onClick={this.stopPropagation} title=""
                            style={expanded ? {}: {display: "none"}}>
                            {map(elems,(item)=>{
                                var commentLine = item.latest_text; // this.textEllipse(item.latest_text,50);
                                var lastUser = item.latest_user_display_name;
                                var commentNav = ''; // TODO "node-" "character-" etc (display name for location or location type)
                                var commentDate = Moment(item.latest_date).format('MM/DD/YY - hh:mm A')
                                return (
                                    <li className="comment-line" key={item.id} onClick={()=>{this.selectComment(item.id)}} title="goto comment">
                                        <span className="comment-type-and-date">{commentNav + commentDate}</span>
                                        <span className="last-comment-modifier">{lastUser}</span>
                                        <span className="dash-after-name">{'-'}</span>
                                        <span className="comment-text">{commentLine}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </MenuItem>
            </li>
        );

    }
    
    render() {
        const allComments = this.state.globalUserStoreState.comments;
        let channel_ups = {};
        let project_ups = {};
        let comments = filter(allComments,(comment)=>{
            // Checked lazily via checkHiddenComments() -- see redmine #7612.
            if (comment.activity_id && this.state.hiddenActivityIds.includes(comment.activity_id)) {
                return false;
            }
            if (comment.short_course_id && this.state.hiddenShortCourseIds.includes(comment.short_course_id)) {
                return false;
            }
            if (!channel_ups[comment.channel_id]) {
                const channelStoreState = ChannelStore.getStateChannel(comment.channel_id);
                const channel = channelStoreState.channel;
                if (!channel) {
                    channel_ups[comment.channel_id] = {}; // no permissions
                }
                else {
                    channel_ups[comment.channel_id] = channel.user_permissions;
                }
            }
            if (!project_ups[comment.project_id]) {
                const projectStoreState = ProjectStore.getStateProject(comment.project_id);
                const _project = comment.short_course_id ? projectStoreState.shortCourseProject : projectStoreState.project;
                if (!_project) {
                    project_ups[comment.project_id] = {}; // no permissions
                }
                else {
                    project_ups[comment.project_id] = _project.user_permissions;
                }
            }
            let canBeAssignedComment = PermissionsUtil.canBeAssignedComment(channel_ups[comment.channel_id], project_ups[comment.project_id]);
            return canBeAssignedComment;
        });
        
        if (!comments || comments.length === 0) {
            return null;
        }
        
        let totalComments = comments.length;
        let act_ids = uniq(map(comments,'activity_id'));
        let short_course_ids = uniq(map(comments,'short_course_id'));
        
        let menuItemElems = [];
        
        
        forEach(act_ids,(activity_id)=>{
            if (!activity_id) {
                return; // skip nulls
            }
            var elems = filter(comments,{activity_id});
            var item = elems[0];
            var ch = find(this.state.channelStoreState.channelsAndOrgs,{id: item.channel_id}) || {name:''};
            var lineText = ch.name + ' > ' + item.project_name + ' > ' + item.activity_name;
            var lineDate = Moment(item.latest_date).format('MM/DD/YY - hh:mm A');
            menuItemElems.push(this.renderMenuItem({
                key: `a_${activity_id}`,
                item, elems, lineText, lineDate,
                expanded: this.state.expandedActivities[activity_id],
                toggleExpanded: (e)=>{this.toggleExpandedActivity(activity_id,e)},
            }));
        });
        
        forEach(short_course_ids,(short_course_id)=>{
            if (!short_course_id) {
                return; // skip nulls
            }
            var elems = filter(comments,{short_course_id});
            var item = elems[0];
            var ch = find(this.state.channelStoreState.channelsAndOrgs,{id: item.channel_id}) || {name:''};
            var lineText = ch.name + ' > ' + item.project_name + ' > ' + item.short_course_name;
            var lineDate = Moment(item.latest_date).format('MM/DD/YY - hh:mm A');
            menuItemElems.push(this.renderMenuItem({
                key: `sc_${short_course_id}`,
                item, elems, lineText, lineDate,
                expanded: this.state.expandedShortCourses[short_course_id],
                toggleExpanded:  (e)=>{this.toggleExpandedShortCourse(short_course_id,e)},
            }));
        });
        
        let modal;
        if (this.state.modalState) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalState;
            modal = (
                <ConfirmModal key="modal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }

        
        return (
            <div className={"comment-widget" + ( this.state.navigatingToComment ? ' navigating':'')}>
                <Wrapper className='AriaMenuButton' onSelection={this.selectActivity}>
                    <Button className='AriaMenuButton-trigger AriaMenuButton-trigger--bare-text'>
                        <div className="comment-widget">
                            <span className="top-number">{totalComments + " comments"}</span>
                        </div>
                    </Button>
                    <Menu>
                        <ul className='AriaMenuButton-menu AriaMenuButton-menu--wide'>
                            {menuItemElems}
                        </ul>
                    </Menu>
                </Wrapper>
                {modal}
            </div>
        )
    }
}

CommentWidget.propTypes = propTypes;
CommentWidget.defaultProps = defaultProps;

module.exports = withRouter(CommentWidget);
